import { getBEMCls } from '@/utils/classname'
import React from 'react'
import { Column, Expaned, Row } from '../layout/layout'
import { DrawerHeader, DrawHeaderProps } from './drawer-header'
import './base-drawer.scss'
import { showLayer, layerManage } from '@/utils/layer'
import { Modal } from '../dialog/modal'
import { usePersistFn } from 'ahooks'

interface BaseDrawerProps extends DrawHeaderProps {
    position?: 'left' | 'right'
    width?: number
    isShow?: boolean
    maskClosable?: boolean
    onClose: () => void
}

export const BaseDrawer: React.FC<BaseDrawerProps> = props => {
    const cls = (b?: string, e?: string) => getBEMCls('base-drawer', b, e)

    const close = usePersistFn(() => {
        layerManage.pop()
    })

    return props.isShow ? (
        <Row data-height-100p>
            <Expaned
                onClick={() => {
                    if (props.maskClosable) {
                        showLayer(
                            <Modal
                                isShow
                                type="danger"
                                onClose={close}
                                onCancel={close}
                                onConfirm={() => {
                                    close()
                                    props.onClose()
                                }}
                            >
                                <div>
                                    <div data-font-size-20 data-color-000 data-font-weight-600>
                                        确认关闭弹窗吗？
                                    </div>
                                </div>
                            </Modal>,
                        )
                    }
                }}
                data-height-100p
            ></Expaned>
            <Column
                data-height-100p
                data-overflow-hidden
                style={{ width: props.width || 540 + 'px' }}
                className={cls()}
            >
                <DrawerHeader {...props}></DrawerHeader>
                <Expaned data-overflow-hidden>{props.children}</Expaned>
            </Column>
        </Row>
    ) : null
}

BaseDrawer.defaultProps = {
    maskClosable: true,
}
